import Column from '@/Components/Grid/Column';
import Container from '@/Components/Grid/Container';
import Row from '@/Components/Grid/Row';
import ContactForm from '@/Components/Universal/ContactForm';
import TopHero from '@/Components/Universal/TopHero';
import useIsServer from '@/Hooks/useIsServer';
import FrontLayout from '@/Layouts/FrontLayout';
import { PageProps } from '@/types';
import { GalleryCategory } from '@/types/models/galleryCategory';
import { Icon } from '@iconify/react';
import { Head, Link } from '@inertiajs/react';
import FsLightbox from "fslightbox-react";
import { Fragment, useState } from 'react';

export default function GallerySingle({ galleryCategory, associatedCategories }: PageProps<{
    galleryCategory: GalleryCategory
    associatedCategories: GalleryCategory[]
}>) {
    const getFormat = (filename: string) => {
        return filename.split('.').pop() as string;
    };

    const isServer = useIsServer()

    let imagesSources: Array<string> = [];
    let imagesAlts: Array<any> = [];

    const [lightboxController, setLightboxController] = useState({
        toggler: false,
        slide: 1,
    });

    function openLightboxOnSlide(number: number) {
        setLightboxController({
            toggler: !lightboxController.toggler,
            slide: number,
        });
    }

    const [selectedCategory, setSelectedCategory] = useState<GalleryCategory | null>(null);

    const toggleCategory = (category: GalleryCategory) => {
        setSelectedCategory(prev => (prev?.id === category.id ? null : category));
    };

    const filteredImages = selectedCategory
        ? selectedCategory.get_gallery || []
        : associatedCategories.flatMap(cat => cat.get_gallery || []);

    filteredImages.forEach((category) => {
        const extension = getFormat(category.photo);
        imagesSources.push(category.photo.replace(extension, 'webp'));
        imagesAlts.push({ alt: category.id });
        // category.get_gallery?.forEach((element) => {
        //     const extension = getFormat(element.photo);

        //     imagesSources.push(element.photo.replace(extension, 'webp'));
        //     imagesAlts.push({ alt: category.name });
        // });
    });

    return (
        <>
            <Head title="Osiedle Kusocińskiego">
                <meta name='description' content='Osiedle Kusocińskiego' />
            </Head>
            <FrontLayout>
                <TopHero image='general-breadcrumbs-bg.webp' text={galleryCategory.name} />
                {!isServer &&
                    <FsLightbox
                        toggler={lightboxController.toggler}
                        sources={imagesSources}
                        customAttributes={imagesAlts}
                        slide={lightboxController.slide}
                    />
                }
                <section className='my-24 maxMd:my-14'>
                    <Container>
                        <Row>
                            <Column>
                                <div>
                                    <div className="flex gap-x-8 items-center justify-center mb-6">
                                        {associatedCategories && associatedCategories.map((cat, i) => {
                                            if (cat.parent_id !== null) {
                                                return (
                                                    <Fragment key={i}>
                                                        <button onClick={() => toggleCategory(cat)} type='button' className={`px-4 py-3 font-extrabold tracking-[0.45px] text-p leading-p text-[#2F2F2F] transition-all ease-in-out duration-300 ${cat === selectedCategory ? 'text-secondary' : ''}`}>{cat.name}</button>
                                                        {i + 1 !== associatedCategories.length - 1 &&
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
                                                                <circle cx="12.5" cy="12" r="10.5" stroke="#004053" />
                                                                <circle cx="12.5" cy="12" r="8.5" stroke="#004053" />
                                                                <circle cx="12.5" cy="12" r="6.5" stroke="#004053" />
                                                            </svg>
                                                        }
                                                    </Fragment>
                                                )
                                            }
                                        }
                                        )}
                                    </div>
                                    <div className='image-grid'>
                                        {filteredImages.map((item, i) => (
                                            <div className={`grid-item ${i % 4 === 3 ? 'single-item' : ''}`} key={item.id}>
                                                <button className="w-full" onClick={() => openLightboxOnSlide(i + 1)}>
                                                    <picture>
                                                        <source
                                                            srcSet={`${item.photo.replace(/\.[^.]+$/, '')}.webp`}
                                                            type="image/webp"
                                                        />
                                                        <source
                                                            srcSet={`${item.photo.replace(/\.[^.]+$/, '')}.${getFormat(item.photo)}`}
                                                            type={`image/${getFormat(item.photo)}`}
                                                        />
                                                        <img
                                                            className="w-full h-[400px] object-cover object-center"
                                                            src={item.photo}
                                                            alt={selectedCategory ? selectedCategory.name : ''}
                                                        />
                                                    </picture>
                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                    <Link href={route('frontend.gallery')} className='button-outline max-w-[320px] ml-auto mt-6'>
                                        Wróc do listy kategorii
                                        <Icon icon={`streamline:return-2`} />
                                    </Link>
                                </div>
                            </Column>
                        </Row>
                    </Container>
                </section>
                <ContactForm smallerMargin />
            </FrontLayout>
        </>
    );
}
